export const GENERIC_REQUEST_ERROR_MESSAGE =
  'Unable to complete your request. Please check your network connection and try again';
